var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepeatable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 40",
    style: {
      enableBackground: "new 0 0 32 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,13.2H7c-0.8,0-1.5,0.7-1.5,1.5v13.6c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5V14.7c0-2.5,2-4.5,4.5-4.5 h11.8L17.6,9c-0.6-0.5-0.6-1.4,0-2s1.5-0.6,2.1-0.1c0,0,0.1,0,0.1,0.1l3.7,3.7c0.6,0.6,0.6,1.5,0,2.1l-3.7,3.7 c-0.3,0.3-0.7,0.4-1.1,0.4c-0.8,0-1.5-0.7-1.5-1.5c0-0.4,0.2-0.8,0.4-1.1L18.8,13.2z M28,10.2c-0.8,0-1.5,0.7-1.5,1.5v13.6 c0,0.8-0.7,1.5-1.5,1.5l0,0H13.2l1.2-1.2c0.6-0.6,0.5-1.6-0.1-2.1s-1.5-0.5-2,0l-3.7,3.7c-0.6,0.6-0.6,1.5,0,2.1l3.7,3.7 c0.6,0.6,1.5,0.6,2.1,0s0.6-1.5,0-2.1l0,0l-1.2-1.2H25c2.5,0,4.5-2,4.5-4.5V11.7C29.5,10.9,28.8,10.2,28,10.2L28,10.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatable);
export default __webpack_public_path__ + "static/media/repeatable.c0895dbef2875cc8e0832558866f66ed.svg";
export { ForwardRef as ReactComponent };